import { ability, defineRulesFor } from "@/plugins/ability";

const Users = {
  namespaced: true,
  state: {
    oneUser: null,
    user: null
  },
  mutations: {
    setCurrentUser(state, data) {
      state.user = data;
    },
    login(state, user) {
      // automatizada na configuração de parse e fetch user - plugins/vue-auth
      state.user = user;
      localStorage.setItem('has_companies', user.comp_ids.length )
      // ability.update(user.rules);
    },
    logout(state) {
      state.user = null;
      localStorage.removeItem('company_id')
      localStorage.removeItem('company_tk')
      localStorage.removeItem('has_companies')
      // ability.update([]);
    }
  },

  actions: {
    getCurrentUser(context, data) {
      context.commit("setCurrentUser", data);
      // if (data) context.commit("setTokenData", localStorage.auth_token_default);
    },
    logout({dispatch, commit}) {
      commit('logout')
      dispatch('App/setActiveCompanyId', null, {root: true});
      dispatch('Event/clearAllEvents', null, {root: true});
      // ability.update([]);
    }
  }
};

export default Users;
